/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freefeature31Inputs */

const zh_plan_freefeature31 = /** @type {(inputs: Plan_Freefeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区支持`)
};

const en_plan_freefeature31 = /** @type {(inputs: Plan_Freefeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community support`)
};

const es_plan_freefeature31 = /** @type {(inputs: Plan_Freefeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte comunitario`)
};

/**
* | output |
* | --- |
* | "Community support" |
*
* @param {Plan_Freefeature31Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freefeature31 = /** @type {((inputs?: Plan_Freefeature31Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freefeature31Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freefeature31(inputs)
	if (locale === "en") return en_plan_freefeature31(inputs)
	return es_plan_freefeature31(inputs)
});
export { plan_freefeature31 as "plan_freeFeature3" }